
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("5pqIV", function(module, exports) {
$parcel$export(module.exports, "default", () => $40a31f224d654a23$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $eikN5 = parcelRequire("eikN5");

var $4NEt5 = parcelRequire("4NEt5");

var $4cTDP = parcelRequire("4cTDP");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $40a31f224d654a23$var$NewIssueCreateTrigger = (0, $eikN5.lazyAfterPaint)(()=>(parcelRequire("fAYbx")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/new-issue-create-trigger/src/index.tsx"
});
const $40a31f224d654a23$var$LazyNewIssueCreateTrigger = ()=>(0, $4cTDP.fg)('error_boundaries_to_common_package') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "async.jira.new-issue-create-trigger",
        packageName: "jiraNewIssueCreateTrigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "new-issue-create-trigger",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($40a31f224d654a23$var$NewIssueCreateTrigger, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.jira.new-issue-create-trigger",
        packageName: "jiraNewIssueCreateTrigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "new-issue-create-trigger",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($40a31f224d654a23$var$NewIssueCreateTrigger, null)));
var $40a31f224d654a23$export$2e2bcd8739ae039 = $40a31f224d654a23$var$LazyNewIssueCreateTrigger;

});
parcelRegister("fAYbx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jZb32").then(()=>parcelRequire('72ggt'));

});



$parcel$global.rlb("248Cj")
//# sourceMappingURL=async.e52ebba2.js.map
